import { Formik } from 'formik';
import moment from 'moment';
import * as React from 'react';
import * as Yup from 'yup';

import { ChangeHistoryFilterForm } from './ChangeHistoryFilterForm';
import { useStyles } from './styles';
import { initialChangeHistoryFilter } from '../constants';

import type { ChangeHistoryFilterFormValues, ProductData } from '../constants';

const formValidation = Yup.object().shape({
  dates: Yup.mixed().test('period', 'Período máximo 180 dias', (value) => {
    const [editedAtDate, editedAtFinalDate] = value;

    return moment(editedAtFinalDate, 'DD/MM/YYYY').isSameOrBefore(moment(editedAtDate, 'DD/MM/YYYY').add(179, 'days'));
  }),
});

type ChangeHistoryFilterProps = {
  setFilters: (filter: ChangeHistoryFilterFormValues) => void;
  productData: ProductData;
};

export const ChangeHistoryFilter = ({ setFilters, productData }: ChangeHistoryFilterProps) => {
  const classes = useStyles();

  return (
    <div className={classes.formikContainer}>
      <Formik initialValues={initialChangeHistoryFilter} onSubmit={() => {}} validationSchema={formValidation}>
        {(props) => <ChangeHistoryFilterForm setFilters={setFilters} productData={productData} {...props} />}
      </Formik>
    </div>
  );
};
